// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {deleteRegistration as repoDeleteRegistration} from '../../shared/repositories';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const deleteRegistration = registrationID =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await repoDeleteRegistration(registrationID);

            dispatch({
                registrationID,
                type: actions.DELETE_REGISTRATION_SUCCESS
            });

            successAlertBar(translate('DELETE_REGISTRATION_SUCCESS'));

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/registration-review/action-creators/delete-registration.js